
















import { Component, Prop, Emit, Vue } from "vue-property-decorator";

import SimpleMessageDialog from "@/components/common/SimpleMessageDialog.vue";

@Component({
  components: {
    SimpleMessageDialog
  }
})
export default class RefreshDialog extends Vue {
  @Prop({ required: true })
  displayRefreshDialog!: boolean;

  @Prop({ required: true })
  isForClient!: boolean;

  @Prop()
  userName!: string;

  get refreshDialogTitle() {
    return this.isForClient
      ? this.$t("Report video/sound issue")
      : this.$t("Video/sound issue reported");
  }

  get refreshDialogText() {
    return this.isForClient
      ? this.$t("We will attempt to refresh the page")
      : `A video or sound issue was reported by ${this.userName}, please contact them through phone, email or other channels of communication. Please contact an administrator if error persist.`;
  }

  @Emit()
  hidePrompt() {
    return;
  }

  @Emit()
  submit() {
    return;
  }
}
